import { useRouter } from "next/router";

import { COOKIES } from "constants/enum";
import { AnalyticsIdElement } from "constants/analytics";
import { getCookiesValueByName } from "utils/cookie";

type GetAnalyticsIdOptions = {
    zone: string;
    element?: AnalyticsIdElement;
    label?: number | string;
};

const NONE = "none";

export const useAnalyticsId = () => {
    const router = useRouter();

    return ({
        zone,
        element = AnalyticsIdElement.BUTTON,
        label = NONE,
    }: GetAnalyticsIdOptions) => {
        let experiments;

        const pathname = router?.asPath
            ?.split("?")[0]
            .split("/")
            .filter(Boolean)
            .join("-");

        try {
            const experimentCookieValue = getCookiesValueByName(
                COOKIES.EXPERIMENTS
            );

            experiments = experimentCookieValue
                ? `${COOKIES.EXPERIMENTS}-${experimentCookieValue
                      .split(",")
                      .join("-")}`
                : NONE;
        } catch (ex) {
            experiments = NONE;
        }

        return [pathname, zone, element, label, NONE, experiments].join("_");
    };
};
